"use client";

import { useRef } from "react";
import { useScroll } from "framer-motion";
import ScrollAnimatedSnakePath from "@/components/common/animations/ScrollAnimatedSnakePath";
import { DesktopServiceStepCard } from "@/components/services/ServiceStepCard";
import { MobileSequentialSteps } from "@/components/services/MobileStepWithPath";
import Button from "@/components/ui/Button";
import {
  serviceSteps,
  desktopSnakePath,
  mobileSnakePaths,
  desktopScrollThresholds,
} from "@/data/servicesData";
import Link from "next/link";

export default function ServicesScrollSection() {
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start center", "end end"],
  });

  return (
    <div
      ref={containerRef}
      className="bg-brand-black relative w-full overflow-visible pt-2 pb-32"
    >
      {/* Desktop Snake Path */}
      <div className="pointer-events-none absolute top-0 left-0 hidden h-full w-full lg:block">
        <div className="h-full w-full lg:px-[100px]">
          <ScrollAnimatedSnakePath
            pathD={desktopSnakePath}
            scrollYProgress={scrollYProgress}
            strokeWidth={0.05}
            className="h-full w-full"
          />
        </div>
      </div>

      <div className="mb:20 relative z-10 flex items-center justify-center lg:mb-64">
        <Link href="/games">
          <Button variant="gradient">View our Games</Button>
        </Link>
      </div>

      <div className="relative z-10 w-full px-5 md:px-12 lg:px-[100px]">
        {/* Desktop Service Steps */}
        <div className="hidden space-y-48 lg:block">
          {serviceSteps.map((step, index) => (
            <DesktopServiceStepCard
              key={index}
              step={step}
              index={index}
              scrollYProgress={scrollYProgress}
              thresholds={desktopScrollThresholds}
            />
          ))}
        </div>

        {/* Mobile Service Steps with Sequential Animation */}
        <div className="lg:hidden">
          <MobileSequentialSteps
            steps={serviceSteps}
            pathDefinitions={mobileSnakePaths}
          />
        </div>
      </div>
    </div>
  );
}
